export default __webpack_public_path__ + "static/media/ff.efa14c50.jpeg";